<script lang="ts" setup>
import { i18n } from '@/i18n';

const t = i18n.t;

defineProps<{
  isError?: boolean;
  errorMessage?: string;
}>();
</script>
<template>
  <div v-if="isError && errorMessage" class="error-message__container">
    <p class="error-message__text">{{ t(errorMessage) }}</p>
  </div>
</template>
<style lang="scss" scoped>
.error-message {
  &__text {
    font-family: Noto Sans JP;
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    text-align: left;

    color: $semanticError;
  }
}
</style>
